'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard(title, body) {
  this.iL = null;
  this.iK = null;
  this.iL = title;
  this.iK = body;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard as $c_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard as $h_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard };
$h_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-723368835), true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard) && ((this.iL === x$0.iL) && (this.iK === x$0.iK))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "UseCaseCard";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.iL;
  }
  if ((n === 1)) {
    return this.iK;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bN)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard };
var $d_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard, "io.intela.sites.digitalinternship.data.Segments$UseCaseCard", ({
  bN: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard as $d_Lio_intela_sites_digitalinternship_data_Segments$UseCaseCard };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Use-Case-Card.js.map
